module.exports = __webpack_public_path__ + "img/1intro-1_ergebnis.d4984651.webp";